export default __webpack_public_path__ + "static/media/crawle-pinout-v2.2@2x.0e7641c5.png";